module.exports = __webpack_public_path__ + "img/stripe-logo.6a91b116.svg";